<template>
<div class="card card-table-two mg-t-20" v-loading='loading'>
    <div style="background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;">
        <h6 class="card-title" style="text-transform:none;font-size:0.875rem;margin-bottom:25px">Unmatched Transactions</h6>
        <small style="margin-bottom:20px">{{fy}}</small>
    </div>
    
    <div class="table-responsive tx-13">
        <table class="table table-striped table-dashboard-two mg-b-0">
        <thead>
            <tr>
            <th class="wd-lg-25p"></th>
            <th class="wd-lg-25p tx-right">{{this_year-2}} - {{this_year-1}} FY</th>
            <th class="wd-lg-25p tx-right">{{this_year-1}} - {{this_year}} FY</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>Deposits</td>
            <td class="tx-right tx-medium tx-inverse">{{credit_prev}}</td>
            <td class="tx-right tx-medium tx-inverse">{{credit}}</td>
            </tr>
            <tr>
            <td>Withdrawals</td>
            <td class="tx-right tx-medium tx-inverse">{{debit_prev}}</td>
            <td class="tx-right tx-medium tx-inverse">{{debit}}</td>
            </tr>
        </tbody>
        </table>
    </div><!-- table-responsive -->
</div><!-- card-dashboard-five -->
</template>
<script>
import dateformats from '../../../utils/dateformats'
import currentformats from '../../../utils/currentformats'
export default {
    name:'fundunmatched',
    components: { 

    },
    data(){
        return{
            fy: dateformats.getFinancialYear(),
            this_year: dateformats.getThisFY(),
            credit:'',
            crediv_prev:'',
            debit:'',
            debit_prev:'',
            loading:true
        }
    },
    created(){
        this.getUnmatched();
    },
    methods:{
        getUnmatched: function(){
            this.$api.funddashboard_api.fundUnmatched(this.$route.params.fund_code).then(response =>{
                //note that the data for prev year and this year is reversed
                this.credit = currentformats.AUformat(response.data['unmatched'][0]['unmatched_credit_prev'])
                this.credit_prev = currentformats.AUformat(response.data['unmatched'][0]['unmatched_credit'])
                this.debit=currentformats.AUformat(response.data['unmatched'][0]['unmatched_debit_prev'])
                this.debit_prev=currentformats.AUformat(response.data['unmatched'][0]['unmatched_debit'])
                this.loading=false
            });
        
        },
    }
}
</script>